import { render, staticRenderFns } from "./ContactGroupEdit.vue?vue&type=template&id=d28f0a8a&scoped=true&"
import script from "./ContactGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ContactGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28f0a8a",
  null
  
)

export default component.exports